// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__wcmzH","addressWrapper":"styles_addressWrapper__7dt2w","qr":"styles_qr__A2aq0","title":"styles_title__vcihM","walletID":"styles_walletID__rzCqt"};